module.exports = __webpack_public_path__ + "static/img/pic_cpr_kcpx@2x.cc8be468.png";